import parseISO from "date-fns/parseISO";

// This function allows us to handle timezone offsets since the date-fns
// library does not support time zones at the moment.
//
// We now use date-fns 2 alpha which handles gracefully date parsing, so this
// function is here for compatibility with previous code and should be ported
// when possible.
//
export default function parseDate(string) {
  return parseISO(string);
}
